module.exports = __webpack_public_path__ + "img/slide-41.be36a98d.jpeg";